<div class="card-nivel-perfil">
  <div class="icon-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="24"
      viewBox="0 0 28 24"
      fill="none"
    >
      <path
        d="M1.31795 24C1.0735 24 0.851282 23.9389 0.651282 23.8167C0.451282 23.6944 0.295727 23.5333 0.184615 23.3333C0.0735043 23.1333 0.0123932 22.9167 0.00128205 22.6833C-0.00982906 22.45 0.0512821 22.2222 0.184615 22L12.5179 0.666667C12.6513 0.444444 12.8235 0.277778 13.0346 0.166667C13.2457 0.0555556 13.4624 0 13.6846 0C13.9068 0 14.1235 0.0555556 14.3346 0.166667C14.5457 0.277778 14.7179 0.444444 14.8513 0.666667L27.1846 22C27.3179 22.2222 27.3791 22.45 27.3679 22.6833C27.3568 22.9167 27.2957 23.1333 27.1846 23.3333C27.0735 23.5333 26.9179 23.6944 26.7179 23.8167C26.518 23.9389 26.2957 24 26.0513 24H1.31795ZM3.61795 21.3333H23.7513L13.6846 4L3.61795 21.3333ZM13.6846 20C14.0624 20 14.3791 19.8722 14.6346 19.6167C14.8902 19.3611 15.0179 19.0444 15.0179 18.6667C15.0179 18.2889 14.8902 17.9722 14.6346 17.7167C14.3791 17.4611 14.0624 17.3333 13.6846 17.3333C13.3068 17.3333 12.9902 17.4611 12.7346 17.7167C12.4791 17.9722 12.3513 18.2889 12.3513 18.6667C12.3513 19.0444 12.4791 19.3611 12.7346 19.6167C12.9902 19.8722 13.3068 20 13.6846 20ZM13.6846 16C14.0624 16 14.3791 15.8722 14.6346 15.6167C14.8902 15.3611 15.0179 15.0444 15.0179 14.6667V10.6667C15.0179 10.2889 14.8902 9.97222 14.6346 9.71667C14.3791 9.46111 14.0624 9.33333 13.6846 9.33333C13.3068 9.33333 12.9902 9.46111 12.7346 9.71667C12.4791 9.97222 12.3513 10.2889 12.3513 10.6667V14.6667C12.3513 15.0444 12.4791 15.3611 12.7346 15.6167C12.9902 15.8722 13.3068 16 13.6846 16Z"
        fill="#00095B"
      />
    </svg>
  </div>
  @if (errorMessage()) {
  <div class="label-container">
    <p>{{ errorMessage() }}</p>
  </div>
  }
  <div class="button-container">
    @if (isLoadingState()) {
      <lib-ui-shimmer-fragment type="rectangle" height="25" width="100" marginBottom="15" />
    } @else {
      <lib-button
        type="secondary"
        id="retry-button"
        [disabled]="false"
        (clickButton)="retry.emit()"
      >
        {{ labelButton() }}
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="18"
            viewBox="0 0 15 18"
            fill="none"
          >
            <path
              d="M6.5 17.3345C4.62433 17.0908 3.07208 16.2646 1.84325 14.8558C0.614417 13.4468 0 11.7961 0 9.90375C0 8.88708 0.200667 7.91308 0.602 6.98175C1.00333 6.05025 1.5655 5.23192 2.2885 4.52675L3.35775 5.596C2.74358 6.15633 2.28042 6.80667 1.96825 7.547C1.65608 8.28733 1.5 9.07292 1.5 9.90375C1.5 11.3704 1.96825 12.6631 2.90475 13.7818C3.84125 14.9003 5.03967 15.5845 6.5 15.8345V17.3345ZM8.5 17.3538V15.8538C9.94367 15.5614 11.1379 14.8618 12.0828 13.7548C13.0276 12.6478 13.5 11.3641 13.5 9.90375C13.5 8.23708 12.9167 6.82042 11.75 5.65375C10.5833 4.48708 9.16667 3.90375 7.5 3.90375H7.14625L8.49625 5.25375L7.44225 6.3075L4.2885 3.15375L7.44225 0L8.49625 1.05375L7.14625 2.40375H7.5C9.59233 2.40375 11.3654 3.13067 12.8193 4.5845C14.2731 6.03833 15 7.81142 15 9.90375C15 11.7858 14.384 13.4281 13.152 14.8308C11.9198 16.2333 10.3692 17.0742 8.5 17.3538Z"
              fill="#00095B"
            />
          </svg>
        </span>
      </lib-button>
    }
  </div>
</div>

<p>{{ labelError() }}</p>
